import axios from "axios";
import { clearCatalogCache } from "../utils/filterCache";

export default {
  namespaced: true,

  state: {
    userData: null,
    logedin: false
  },

  getters: {
    user: state => state.userData
  },

  mutations: {
    setUserData(state, user) {
      state.userData = user;
    }
  },

  actions: {
    getUserData({ commit }) {
      axios
        .get(process.env.VUE_APP_API_URL + "auth/profile")
        .then(response => {
          const user = response.data;
          commit("setUserData", user);
          if (user && user.integradores) {
            commit("integrador/setIntegradores", user.integradores, { root: true });
          }
          const currentStored = localStorage.getItem("integrador");
          let isValid = false;
          if (currentStored && user) {
            if (user.rol === "admin" || currentStored === "todos") {
              isValid = true;
            } else if (user.integradores && Array.isArray(user.integradores)) {
              isValid = user.integradores.some(
                i => String(i.id_integrador || i.id) === String(currentStored)
              );
            }
          }

          if (isValid) {
            commit("integrador/setIntegrador", currentStored, { root: true });
          } else {
            let sel = user && user.id_integrador;
            if (!sel && user && user.integradores && user.integradores.length > 0) {
              sel = user.integradores[0].id_integrador || user.integradores[0].id;
            }
            if (sel) {
              localStorage.setItem("integrador", sel);
              commit("integrador/setIntegrador", sel, { root: true });
            }
          }
        })
        .catch(() => {
          localStorage.removeItem("authToken");
        });
    },
    sendLoginRequest({ commit }, data) {
      commit("setErrors", {}, { root: true });
      commit("setError", null, { root: true });
      return axios
        .post(process.env.VUE_APP_API_URL + "auth/login", data)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.success
          ) {
            const user = response.data.data.user;
            if (user && user.integradores && Array.isArray(user.integradores)) {
              user.integradores.sort((a, b) =>
                String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
              );
            }
            commit("setUserData", user);
            if (user.integradores) {
              commit("integrador/setIntegradores", user.integradores, { root: true });
            }
            const currentStored = localStorage.getItem("integrador");
            let isValid = false;
            if (currentStored && user) {
              if (user.rol === "admin" || currentStored === "todos") {
                isValid = true;
              } else if (user.integradores && Array.isArray(user.integradores)) {
                isValid = user.integradores.some(
                  i => String(i.id_integrador || i.id) === String(currentStored)
                );
              }
            }

            let sel = isValid
              ? currentStored
              : (user.id_integrador || (user.integradores && user.integradores.length > 0 ? (user.integradores[0].id_integrador || user.integradores[0].id) : null));

            if (sel) {
              localStorage.setItem("integrador", sel);
              commit("integrador/setIntegrador", sel, { root: true });
            } else {
              localStorage.removeItem("integrador");
              commit("integrador/setIntegrador", null, { root: true });
            }
            localStorage.setItem("authToken", response.data.data.token);
            if (response.data.data.refresh_token) {
              localStorage.setItem("refreshToken", response.data.data.refresh_token);
            }
          } else if (response && response.data && response.data.error) {
            const err = typeof response.data.error === "string"
              ? response.data.error
              : (response.data.error.message || response.data.message || "Error al iniciar sesión");
            commit("setError", err, { root: true });
          }
        })
        .catch(error => {
          const resp = error.response;
          if (resp && resp.data) {
            const data = resp.data;
            let msg = null;
            if (typeof data === "string") {
              msg = data;
            } else if (typeof data.error === "string") {
              msg = data.error;
            } else if (data.error && data.error.message) {
              msg = data.error.message;
            } else if (data.message) {
              msg = data.message;
            } else if (typeof data.detail === "string") {
              msg = data.detail;
            } else if (Array.isArray(data.detail) && data.detail.length && data.detail[0].msg) {
              msg = data.detail[0].msg;
            }

            let errors = data.errors || (data.error && data.error.data && data.error.data.errors) || null;
            if (!errors && data.detail && Array.isArray(data.detail)) {
              errors = {};
              data.detail.forEach(item => {
                const field = item.loc && item.loc[item.loc.length - 1];
                if (field) {
                  errors[field] = [item.msg];
                }
              });
            }
            if (errors) {
              commit("setErrors", errors, { root: true });
            }
            commit("setError", msg || "Error de usuario o contraseña", { root: true });
          } else {
            commit("setError", "No se puede conectar al servidor", { root: true });
          }
          return Promise.reject(error);
        });
    },
    sendLogoutRequest({ commit }) {
      commit("setUserData", null);
      commit("integrador/clearIntegradores", null, { root: true });
      clearCatalogCache();
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("integrador");
      return axios.post(process.env.VUE_APP_API_URL + "auth/logout").catch(() => {});
    }

  }
};
